import { endpoints, getIDFromUrl, ID } from '@rossum/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../../lib/apiClient';
import { QUERY_KEY_QUEUE } from '../../../queues/hooks/useQueue';
import { usePatchEmailTemplate } from './usePatchEmailTemplate';

export const useAutomateQueueEmailTemplate = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: patchEmailTemplate } = usePatchEmailTemplate();

  const { mutateAsync: automateQueueEmailTemplate } = useMutation({
    mutationFn: async (queueId: ID) => {
      return api
        .request(
          endpoints.triggers.list({
            queue: queueId,
            event: 'annotation_created',
          })
        )
        .then(({ results: [trigger] }) => {
          if (!trigger) return;

          const emailTemplate = trigger.emailTemplates[0];

          if (!emailTemplate) return;

          patchEmailTemplate({
            emailTemplateId: getIDFromUrl(emailTemplate),
            emailTemplatePatchModel: {
              automate: true,
            },
          });
        });
    },
    onSettled: (_data, _error, queueId) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_QUEUE, queueId],
      });
    },
  });
  return {
    automateQueueEmailTemplate,
  };
};
